<template>
  <div class="email-app-details" :class="active ? 'show' : ''">
    <div class="iq-card">
      <div class="iq-card-body p-0">
        <div class="">
          <div class="iq-email-to-list p-3">
            <div class="d-flex justify-content-between">
              <ul>
                <li class="mr-3">
                  <a href="javascript: void(0);" @click="closeDetail(item)">
                    <h6 class="m-0 back"><i class="ri-arrow-left-line" /></h6>
                  </a>
                </li>
                <!-- <li v-b-tooltip.top title="Read">
                  <a href="#"><i class="ri-mail-open-line" /></a>
                </li>
                <li v-b-tooltip.top title="Info">
                  <a href="#"><i class="ri-information-line" /></a>
                </li> -->
                <li v-b-tooltip.top title="Delete">
                  <a href="#" @click="deleteItem"
                    ><i class="ri-delete-bin-line"
                  /></a>
                </li>
                <li v-b-tooltip.top title="Unread">
                  <a href="#" @click="markAsUnread"
                    ><i class="ri-mail-unread-line"
                  /></a>
                </li>
                <!-- <li v-b-tooltip.top title="Forward">
                  <a href="#"><i class="ri-folder-transfer-line" /></a>
                </li>
                <li v-b-tooltip.top title="Bookmark">
                  <a href="#"><i class="ri-bookmark-line" /></a>
                </li> -->
              </ul>
              <div class="iq-email-search d-flex">
                <ul>
                  <li class="mr-3">
                    <a class="font-size-14" href="#"
                      >{{ item.index }} of {{ emailItems.length }}</a
                    >
                  </li>
                  <li v-b-tooltip.top title="Previous">
                    <a href="#" @click="navigateBack"
                      ><i class="ri-arrow-left-s-line"
                    /></a>
                  </li>
                  <li v-b-tooltip.top title="Next">
                    <a href="#" @click="navigateForward"
                      ><i class="ri-arrow-right-s-line"
                    /></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <hr class="mt-0" />
          <div class="iq-inbox-subject p-3">
            <h5 class="mt-0 mb-3">
              {{ item.subject }}
            </h5>
            <div class="iq-inbox-subject-info">
              <div class="iq-subject-info">
                <img
                  :src="require('../../../assets/images/user/1.jpg')"
                  class="img-fluid rounded-circle"
                  alt="#"
                />
                <div class="iq-subject-status align-self-center">
                  <!-- <h6 class="mb-0">
                    Xray team <a href="dummy@Xray.com">dummy@Xray.com</a>
                  </h6> -->
                  <div class="dropdown">
                    <a
                      class="dropdown-toggle"
                      href="#"
                      id="dropdownMenuButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      to Me
                    </a>
                    <div
                      class="dropdown-menu font-size-12"
                      aria-labelledby="dropdownMenuButton"
                    >
                      <table class="iq-inbox-details">
                        <tbody>
                          <tr>
                            <td>from:</td>
                            <td>Medium Daily Digest</td>
                          </tr>
                          <tr>
                            <td>reply-to:</td>
                            <td>noreply@gmail.com</td>
                          </tr>
                          <tr>
                            <td>to:</td>
                            <td>iqonicdesigns@gmail.com</td>
                          </tr>
                          <tr>
                            <td>date:</td>
                            <td>13 Dec 2019, 08:30</td>
                          </tr>
                          <tr>
                            <td>subject:</td>
                            <td>The Golden Rule</td>
                          </tr>
                          <tr>
                            <td>security:</td>
                            <td>Standard encryption</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <span class="float-right align-self-center">{{
                  item.emailTime.toLocaleString()
                }}</span>
              </div>
              <div class="iq-inbox-body mt-5">
                <p>
                  {{ item.message }}
                </p>
              </div>
              <hr />
              <!-- <div class="attegement">
                <h6 class="mb-2">ATTACHED FILES:</h6>
                <ul>
                  <li class="icon icon-attegment">
                    <i class="fa fa-file-text-o" aria-hidden="true"></i>
                    <span class="ml-1">mydoc.doc</span>
                  </li>
                  <li class="icon icon-attegment">
                    <i class="fa fa-file-text-o" aria-hidden="true"></i>
                    <span class="ml-1">mydoc.pdf</span>
                  </li>
                </ul>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { deleteDoc, doc, updateDoc } from "@firebase/firestore";
import firebase from "../../../../firebase";
import { useRouter } from "vue-router";
import EmailItemVue from "./EmailItem.vue";
export default {
  name: "EmailDetail",
  props: ["item", "active", "emailItems"],
  setup(props, context) {
    const router = useRouter();
    const closeDetail = (item) => {
      context.emit("update", item);
    };
    const deleteItem = () => {
      deleteDoc(doc(firebase.db, "emails", props.item.id));
      closeDetail();
    };
    const markAsUnread = () => {
      updateDoc(doc(firebase.db, "emails", props.item.id), {
        is_unread: true,
      });
      closeDetail();
    };
    const navigateBack = () => {
      const curIndex = props.item.index;
      // console.log(`Navigate backwards  from ${curIndex} to ${curIndex + 1}`);
      context.emit("navigate", curIndex + 1);
    };
    const navigateForward = () => {
      const curIndex = props.item.index;
      // console.log(`Navigate forward from ${curIndex} to ${curIndex - 1}`);
      context.emit("navigate", curIndex - 1);
    };
    return {
      closeDetail,
      deleteItem,
      markAsUnread,
      navigateBack,
      navigateForward,
    };
  },
};
</script>

<style scoped>
 .back {
  font-size: 23px;
  color: var(--accent-color);
 }
</style>
